module.exports = __webpack_public_path__ + "static/media/Malphite.0e760c6c.png";